import React, { useState }  from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'


export default function WaitingList() {
    const [form, setForm] = useState({  PlayerOneFirstName: '', PlayerOneLastName: '', PlayerOneEmail: '', PlayerOneMobile: '' });
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        console.log("submit func gecalled")
        e.preventDefault();
        setStatus("Submitting...");

        try {
            const response = await fetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/waiting-lists', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ data: form }),
            });

            if (!response.ok) throw new Error("Failed to submit");

            setStatus("Message sent successfully!");
            setForm({ PlayerOneFirstName: '', PlayerOneLastName: '', PlayerOneEmail: '', PlayerOneMobile: '' });
        } catch (error) {
            console.error(error);
            setStatus("Error sending message.");
        }
    };


    return(
        <div>
            <Form onSubmit={handleSubmit}>

                <Form.Group className="mb-3" controlId="PlayerOneFirstName">
                    <Form.Label>Vorname</Form.Label>
                    <Form.Control type="text" placeholder="" name="PlayerOneFirstName" value={form.PlayerOneFirstName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneLastName">
                    <Form.Label>Nachname</Form.Label>
                    <Form.Control type="text" placeholder="" name="PlayerOneLastName" value={form.PlayerOneLastName} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneEmail">
                    <Form.Label>E-Mail</Form.Label>
                    <Form.Control type="text" placeholder="" name="PlayerOneEmail" value={form.PlayerOneEmail} onChange={handleChange} required/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="PlayerOneMobile">
                    <Form.Label>Natel</Form.Label>
                    <Form.Control type="text" placeholder="" name="PlayerOneMobile" value={form.PlayerOneMobile} onChange={handleChange} required/>
                </Form.Group>


                <Button variant="primary" type="submit">
                    Anmelden für die Warteliste
                </Button>
                {status && <p>{status}</p>}
            </Form>

        </div>
    )

}